import { render, staticRenderFns } from "./TransportModeTable.vue?vue&type=template&id=904fbf2e"
import script from "./TransportModeTable.vue?vue&type=script&lang=ts"
export * from "./TransportModeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports